export default "__VITE_ASSET__fbd6dd4f__"